import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { HeaderModule } from '@bcef/ia-components/header';
import { PanelModule } from '@bcef/ia-components/panel';
import { IconsModule } from '@bcef/ia-ng-icons';
import { TypologyLiteral } from '@bcef/ia-shared';
import { DataLayered } from '@difa/ia-data-layer';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ChannelType, ClientType, ContractType, RoutesPath } from '@features/termination/enums';
import { TerminationType } from '@features/termination/enums/termination-list.enum';
import { PersonalInformation, TerminationInformation } from '@features/termination/interfaces';
import { ConnectionContextService } from '@features/termination/services';

import { TerminationFacade } from '../../termination.facade';
import { SummaryFacade } from './summary.facade';

@DataLayered('screens.summary.datalayer')
@Component({
  selector: 'ia-resil-contrats-summary',
  templateUrl: './summary.component.html',
  imports: [
    AsyncPipe,
    DatePipe,
    HeaderModule,
    TranslateModule,
    PanelModule,
    TranslateModule,
    ButtonModule,
    CommonModule,
    PanelModule,
    IconsModule,
  ],
})
export class SummaryComponent implements OnInit {
  @HostBinding('class') public classAttribute =
    'tw-flex tw-flex-col md:tw-mt-10 md:tw-pb-24 tw-mx-0 sm:tw-mx-25 tw-pb-10 hb-group:tw-font-hello-type hb-group:tw-mx-0';

  private readonly terminationFacade: TerminationFacade = inject(TerminationFacade);

  private readonly summaryFacade: SummaryFacade = inject(SummaryFacade);

  private readonly connectionContextService: ConnectionContextService =
    inject(ConnectionContextService);

  public isHb: boolean = this.terminationFacade.isHbGroup;

  public get typology(): TypologyLiteral {
    return this.terminationFacade.typology;
  }

  public insurance = ContractType.INSURANCE;

  public TerminationType = TerminationType;

  public readonly PhysicalPerson = ClientType.PHYSICAL_PERSON;

  public readonly Email = ChannelType.EMAIL;
  public readonly Paper = ChannelType.PAPER;

  public readonly personalInformation$: Observable<PersonalInformation> =
    this.terminationFacade.personalInformation$;

  public readonly terminationInformation$: Observable<TerminationInformation> =
    this.terminationFacade.terminationInformation$;

  public readonly terminationInformationText$: Observable<TerminationInformation> =
    this.terminationFacade.terminationInformationText$;

  public readonly isConnected: boolean = this.connectionContextService.isConnected;

  public ngOnInit(): void {
    this.terminationFacade.updateStepInProgress(3);
  }

  public onContactUs(): void {
    this.terminationFacade.openContact();
  }

  public onPrevious(): void {
    this.terminationFacade.navigateTo(RoutesPath.TERMINATION_PAGE);
  }

  public onSubmit(): void {
    if (this.isConnected && !this.terminationFacade.isHbGroup) {
      this.summaryFacade.onSendRequest();
    } else {
      this.summaryFacade.onSendEmail();
    }
  }
}
